import React from "react"
import {
    Button,
    DialogTitle,
    Dialog,
    DialogContent,
    DialogActions,
    styled,
} from "@mui/material"

const StyledDialog = styled(Dialog)({
    "& .MuiPaper-root": {
        width: 500,
        padding: 10
    },
})

const CantDeleteModal = ({
    onClose, open, title, description
}) => {
    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" sx={{ pb: 0 }}>
                {title}
            </DialogTitle>
            {description && (
                <DialogContent sx={{ mt: 1 }}>
                    {description}
                </DialogContent>
            )}
            <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={onClose} color="primary">
                    Retour
                </Button>
            </DialogActions>
        </StyledDialog>
    )
}

export default CantDeleteModal
